import { isArrayWithValues } from '@/utils/fp';
import { Chip, Stack, ChipProps } from '@mui/material';
import { Path, PathValue, UseFormSetValue } from 'react-hook-form';

interface InputFieldSuggestionsProps<T extends object> extends Pick<ChipProps, 'color'> {
    name: string;
    data?: string[];
    setValue: UseFormSetValue<Partial<T>>;
}

export const InputFieldSuggestions = <T extends object>({
    name,
    data,
    color = 'info',
    setValue,
}: InputFieldSuggestionsProps<T>) => {
    if (!isArrayWithValues(data)) return <></>;
    return (
        <Stack
            direction="row"
            sx={{
                flexWrap: 'wrap',
            }}
        >
            {data.map((item) => (
                <Chip
                    label={item}
                    color={color}
                    key={item}
                    size="small"
                    variant="outlined"
                    onClick={() =>
                        setValue(
                            name as Path<Partial<T>>,
                            item as PathValue<Partial<T>, Path<Partial<T>>>,
                        )
                    }
                    sx={{ mr: 1, mb: 1 }}
                />
            ))}
        </Stack>
    );
};
